<!-- app-header hidden temporarily
@if (isPlatformBrowser) {
<div class="app-header">
  <shared-secondary-nav [menuItems]="menuItems" [hasProfileMenu]="false">
  </shared-secondary-nav>
  <button
    #themeTooltip="kendoTooltip"
    kendoTooltip
    position="bottom"
    kendoButton
    sharedIconButton
    [iconKey]="theme() === 'light' ? iconKeys.dark_mode : iconKeys.light_mode"
    look="flat"
    [title]="theme() === 'light' ? 'Dark mode' : 'Light mode'"
    (click)="toggleThemeWithTooltip(themeTooltip, $event.currentTarget)"></button>
</div>
}
-->

<div class="app-layout k-d-flex k-d-flex-col s-width-100" [class.with-global-banner]="isBannerVisible()">
  <main class="app-main">
    <ng-container sharedBannerContainer></ng-container>
    <kendo-splitter class="app-splitter" orientation="horizontal">
      <kendo-splitter-pane class="app-shell">
        <router-outlet></router-outlet>
      </kendo-splitter-pane>
      <kendo-splitter-pane class="app-aura" size="350px" min="350px" max="550px" [collapsible]="true" [(collapsed)]="auraCollapsed">
        @defer (when isPlatformBrowser) {
          <aura-chat
            [config]="chatConfig"
            [selectedAgent]="selectedAgent()"
            [userId]="auraUserId()"
            [context]="chatContext()"
            [language]="language()"
            [historyHost]="historyHost()"
            [analyticsContext]="analyticsContext()"
            [isThemeDark]="isThemeDark()"
            (responseReceived)="onAiResponse($event)"
            (responseError)="onAiError($event)"
            (analyticsEvent)="onAnalyticsEvent($event)"
            (referenceClick)="onReferenceClick($event)"
            (themeToggle)="toggleTheme()">
          </aura-chat>
        }
      </kendo-splitter-pane>
    </kendo-splitter>
  </main>
</div>